import * as z from 'zod';
import { DISALLOW_USAGE_FOR, SPACE_TYPE } from 'src/features/spaces/utils/types';

export type SpaceFormSchemaValues = z.infer<typeof spaceFormSchema>;
export const spaceFormSchema = z.object({
    number: z.string().nonempty(),
    type: z.enum(SPACE_TYPE),
    disallow_usage_for: z.enum(DISALLOW_USAGE_FOR).optional().nullable(),
    zone: z.string().nonempty(),
});

export const bulkSpaceFormSchema = z.object({
    start: z.number().int().min(0),
    end: z.number().int().min(0),
    type: z.enum(SPACE_TYPE),
    disallow_usage_for: z.enum(DISALLOW_USAGE_FOR).optional().nullable(),
    zone: z.string().nonempty(),
});
export type BulkSpaceFormSchemaValues = z.infer<typeof bulkSpaceFormSchema>;